/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HealthControllerDetailedQueryResponse, HealthControllerDetailed503 } from "../../models/healthController/HealthControllerDetailed";

function getHealthControllerDetailedUrl() {
  const res = { method: 'GET', url: `/health/detailed` as const }  
  return res
}

/**
 * @summary Detailed health check with database status
 * {@link /health/detailed}
 */
export async function healthControllerDetailed(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HealthControllerDetailedQueryResponse, ResponseErrorConfig<HealthControllerDetailed503>, unknown>({ method : "GET", url : getHealthControllerDetailedUrl().url.toString(), ... requestConfig })  
  return res.data
}